import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getBuyersGroupList(status_user?: boolean): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Areas/ListPurchasingGroups${status_user !== undefined ? `?status_user=${status_user}` : ''}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}


export function createBuyersGroup(data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post('Areas/RegisterGroups', data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateBuyersGroup(id: string, data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Areas/UpdatePurchasingGroup/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function softDeleteBuyersGroup(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Areas/SoftDeleteGroup/${id}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getAreasList(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Areas/List`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}